import React from 'react'
import { Spinner } from '@/components/spinner';
import { MachinesReportWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { MachinesReportWizardResult } from './Result';
import { MachinesReportWizardSelection } from './Selection';

const maxStep = 2

export const MachinesReportWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  const { step, wizardData } = useWizard<WizardData>()

  if (step === 0) {
    return <MachinesReportWizardStep1  />
  } else if (step === 1 && wizardData.selectMachines) {
    return <MachinesReportWizardSelection />
  } else if (step === 1 || step === 2) {
    return <MachinesReportWizardResult />
  } else return <Spinner />
}

export const MachinesReportWizard = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  return <div className='machinesranking-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <MachinesReportWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const MachinesReportWizardPopup = ({ onClose }: {
  onClose: () => void
}) => {
  return <MachinesReportWizard onDone={onClose} />
}
